import React from 'react';

import { ErdViewerPage } from '~/components/ErdViewer/ErdViewerPage';
import { CONFIGURATION_FEATURES_NAMES } from '~/Types';
import { isFeatureEnabled } from '~/Utils';

import ConfigurationScreenWithTabs from '../ConfigurationScreenWithTabs';
import { useSysconfig } from '../SystemConfigurationScreen';

import BordereauxReportingTab from './BordereauxReporting/BordereauxReportingTab';
import ScheduledDataExportPage from './ScheduledDataExport';

const DATA_REPORTING_ROUTES = {
  DATA_EXPORT: 'data_export',
  BORDEREAUX_REPORTING: 'bordereaux_reporting',
  DATA_MODEL: 'data_model',
};

const DataReportingPage: React.FC = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization, organizationOperationalDetails } = useSysconfig();

  const tabs = [
    {
      label: 'Data Export',
      url: DATA_REPORTING_ROUTES.DATA_EXPORT,
      component: ScheduledDataExportPage,
      isEnabled: isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.SCHEDULED_DATA_EXPORT),
    },
    {
      label: 'Reporting',
      url: DATA_REPORTING_ROUTES.BORDEREAUX_REPORTING,
      component: BordereauxReportingTab,
      isEnabled: !!organizationOperationalDetails?.isMetabaseReportingConfigured,
      className: 'whitespace-nowrap',
    },
    {
      label: 'Data Model',
      url: DATA_REPORTING_ROUTES.DATA_MODEL,
      component: ErdViewerPage,
      isEnabled: !!organizationOperationalDetails?.isMetabaseEnabled,
      className: 'whitespace-nowrap',
    },
  ];

  return (
    <ConfigurationScreenWithTabs
      tabs={tabs}
      title="DATA & REPORTING"
      subtitle="Create one-time or scheduled data exports, manage report templates, and explore the reporting data model."
      operationTabName="Data & Reporting"
    />
  );
};

export default DataReportingPage;
